import useVideoTrim from "src/hooks/useVideoTrim";
import { all } from "axios";
import { useState } from "react";
import { styled } from "styled-components";
import { useBoundStore } from "src/store";
import { useNavigate } from "react-router-dom";

interface ProgressBarProps {
    percentage: number;
    text: string;
  }
  
  const Wrapper = styled.div`
    margin-top: 2px; /* Tailwind mt-0.5 = 0.125rem = 2px */
    width: 100%;
    position: relative;
    font-size: 0.875rem; /* text-sm */
    color: white;
    background-color: #e5e7eb; /* bg-gray-200 */
    border: 1px solid #9ca3af; /* border-gray-400 */
    border-radius: 0.5rem; /* rounded-lg */
    text-align: left;
    overflow: hidden;
  `;
  
  const Fill = styled.div<{ percentage: number }>`
    position: relative;
    height: 100%;
    white-space: nowrap;
    padding: 0 0.5rem; /* px-2 */
    background-color: #3b82f6; /* bg-blue-500 */
    width: ${({ percentage }) => `${percentage}%`};
    transition: width 0.3s ease;
  `;

  const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, text }) => {
    return (
      <Wrapper>
        <Fill percentage={percentage}>
          {text} ({percentage.toFixed(2)}%)
        </Fill>
      </Wrapper>
    );
  };
const Process: React.FC<{ progress:number}> = ({progress})=>{
    
 
    
    return(
        <div>
        
              <>
              <div>Processig all your videos</div>
              <ProgressBar percentage={progress} text="Processing" />
              </>
            
            
        </div>
    )
}

export default Process;


